import { useKeycloakQueries, useAuth } from "@inbody/keycloak";
const ORG_TREE_STALE_TIME = 1e3 * 60 * 10;
const useOrgTree = () => {
  const { useFetchGroupUserTree } = useKeycloakQueries();
  const { corporateCode } = useAuth();
  const { data: orgTree } = useFetchGroupUserTree(corporateCode, {
    staleTime: ORG_TREE_STALE_TIME
  });
  return { orgTree };
};
export {
  useOrgTree
};
